import React, { useRef, useCallback, useMemo } from "react";
import styles from "styles.module.css";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { fisheryDepartmentNoteGridColumns } from "./utilities/columnGrid";
import { PageTypePath } from "utils/pages";
import { FisheryDepartmentNote } from "interface/registration";
import GridWithGroupPaging from "ui/grid/GridWithGroupPaging";
import Filter from "./utilities/Filter";
import CustomButton from "ui/Button";
import { ICON_NAMES } from "utils/constant";

interface FisheryDepartmentNotesProps {
	id: number;
	title: string;
	apiMethod: (id: number) => Promise<any>;
}

const FisheryDepartmentNotes: React.FC<FisheryDepartmentNotesProps> = ({
	id,
	title,
	apiMethod,
}) => {
	const excelRef = useRef<ExcelExport>(null);

	const exportAsExcel = useCallback(() => {
		if (excelRef.current !== null) {
			excelRef.current.save();
		}
	}, []);

	const handlePrint = useCallback((item: FisheryDepartmentNote) => {
		if (item.reportGuid) {
			window.open(`/${PageTypePath.Pdf}/${item.reportGuid}`, "_blank");
		}
	}, []);

	// Memoize the grid columns
	const gridColumns = useMemo(
		() => fisheryDepartmentNoteGridColumns({ onPrint: handlePrint }),
		[handlePrint]
	);

	// Memoize the API method wrapper
	const memoizedApiMethod = useCallback(
		() => apiMethod(id).then((res) => res?.data ?? []),
		[apiMethod, id]
	);

	const openPdf = async (id: string) => {
		console.log('id', id);
		localStorage.setItem("noteNumber", id);

		window.open(`/${PageTypePath.Pdf}/${id}`, "_blank");
		return;
	};

	return (
		<div className={styles.PageContainer}>
			<div className="page-header">
				<legend className={styles.BoxHeadingLarge}>{title}</legend>
			</div>
			<Filter exportAsExcel={exportAsExcel} />
			<GridWithGroupPaging
				gridColumns={gridColumns}
				apiMethod={memoizedApiMethod}
				filter={id}
				pageable={false}
				itemAboveHeight={100}
				exportGridAsExcelRef={excelRef}
				lastColBtns={{
					width: 50,
					cells: {
						data: (props) => {
							return (
								<td>
									<CustomButton
										onClick={() => openPdf(props.dataItem.reportGuid)}
										iconName={ICON_NAMES.Download}
										btnStyle={{ backgroundColor: "transparent" }}
										label=""
									/>
								</td>
							);
						},
					},
				}}

			/>
		</div>
	);
};

export default FisheryDepartmentNotes;
